import { Box, Typography } from "@mui/material";

interface Props {
  bullets: string[];
}

const ClassificationBullets = ({ bullets }: Props) => {
  if (bullets.length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="subtitle2">Here is what you can do</Typography>
      <Box component="ul" sx={{ pl: 3, m: 0 }}>
        {bullets.map((bullet, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <Typography key={index} component="li" color="textSecondary" sx={{ whiteSpace: "pre-line" }}>
            {bullet}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default ClassificationBullets;
